import type { WorkflowDefinitionsFilterValues } from '@/pages/WorkflowDefinitions/types/workflow-definitions-filter-values';
import type { WorkflowDefinitionsQueryParams } from '@/pages/WorkflowDefinitions/types/workflow-definitions-query-params';

export const deserializeQueryParams = (query: WorkflowDefinitionsQueryParams) => {
  const filters: WorkflowDefinitionsFilterValues = {
    page: query.page!,
    limit: query.limit!,
    public: query.public!,
  };

  return filters;
};
